import { useLayoutEffect, type ReactNode } from "react";
import { StarLogo } from "./StarLogo";
import { DecodeText } from "./DecodeText";
import { IconChevronRight } from "./icons";
import { useI18n } from "../i18n";
import { authStepRendered, useAuthNav } from "../authTransition";
import "./AuthLayout.css";

const POEM =
  "在赛博朋克的世界里，高科技和黑暗势力共存。人们身处于发达的城市中，但生活却一直受到巨大的限制和控制。虚拟世界和现实世界之间的界限愈来愈模糊，让人们感到困惑和迷失。";

function formatToday() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}.${m}.${day}`;
}

export function AuthLayout({
  title,
  children,
  footer,
  showBack,
}: {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  showBack?: boolean;
}) {
  const { t } = useI18n();
  const { back } = useAuthNav();
  // Lets a step-to-step view transition (see authTransition.ts) capture this step.
  useLayoutEffect(authStepRendered, []);
  return (
    <div className="auth">
      {showBack ? (
        <button
          type="button"
          className="auth__back"
          aria-label={t("auth.back")}
          title={t("auth.back")}
          onClick={back}
        >
          <IconChevronRight width={20} height={20} style={{ transform: "rotate(180deg)" }} />
        </button>
      ) : null}
      <p className="auth__poem">{POEM}</p>
      <p className="auth__brand">{t("meta.brand")}</p>
      <p className="auth__date">{formatToday()}</p>
      <div className="auth__bar-v" />
      <div className="auth__ticks">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="auth__cursor" />

      <div className="auth__content anim-fade-in">
        <StarLogo />
        <h1 className="auth__title" aria-label={title}>
          <DecodeText text={title} />
        </h1>
        <div className="auth__form">{children}</div>
        {footer}
      </div>
    </div>
  );
}
